export class SwiperFadeItems {
    constructor(containerSelector, targetSelector, mediaQuery = '(min-width: 768px)', options = {}) {
        // Store the provided selectors and media query
        this.containerSelector = containerSelector;
        this.targetSelector = targetSelector;
        this.mediaQuery = window.matchMedia(mediaQuery);
        
        // Default observer options, merged with any provided options
        this.observerOptions = {
            root: null,
            threshold: 0.75,
            ...options,
        };
        
        this.observer = null;
        
        // Bind the resize handler to ensure correct `this` context
        this.handleMediaChange = this.handleMediaChange.bind(this);
        
        // Add a media query listener to handle viewport changes
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
        
        // Initialize the observer if the media query matches initially
        if (this.mediaQuery.matches) {
            this.init();
        }
    }

    init() {
        // Select the container element
        const container = document.querySelector(this.containerSelector);
        if (!container) return; // Exit if container is not found
        
        // Select target elements within the container
        const targets = container.querySelectorAll(this.targetSelector);
        
        // Define observer callback to toggle visibility classes
        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                const isNotInView = !entry.isIntersecting;
                entry.target.classList.toggle('not-in-view', isNotInView);
                entry.target.setAttribute('aria-hidden', isNotInView);
            });
        };
        
        // Create Intersection Observer with provided options
        this.observer = new IntersectionObserver(observerCallback, {
            ...this.observerOptions,
            root: container, // Ensure observations happen relative to the container
        });
        
        // Start observing each target element
        targets.forEach((target) => this.observer.observe(target));
    }

    destroy() {
        // If observer exists, remove classes and disconnect
        if (this.observer) {
            const targets = document.querySelectorAll(
                `${this.containerSelector} ${this.targetSelector}`
            );
            
            // Reset styles and attributes for each observed element
            targets.forEach((target) => { 
                target.classList.remove('not-in-view');
                target.setAttribute('aria-hidden', false);
            });
            
            // Disconnect observer and clean up
            this.observer.disconnect();
            this.observer = null;
        }
    }

    handleMediaChange(event) {
        // If media query matches, initialize observer; otherwise, destroy it
        if (event.matches) {
            this.init();
        } else {
            this.destroy();
        }
    }

    removeMediaQueryListener() {
        // Remove the media query listener when no longer needed
        this.mediaQuery.removeEventListener('change', this.handleMediaChange);
    }
}

/** 
 *  Example Usage:
 *      const swiperFadeItems = new SwiperFadeItems('.swiper', '.swiper-slide');
*/